import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, map, catchError, throwError } from 'rxjs';

import { CerAuthorizeService } from '../cer-authorize.service';

@Injectable()
export class CerAuthorizeInterceptor implements HttpInterceptor {

  constructor(private authService: CerAuthorizeService) {}
  
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const loginUrl = this.authService.loginUrl();
    return next.handle(request).pipe(
      catchError( error =>  {
        if (error instanceof HttpErrorResponse && error.url?.startsWith(loginUrl)) {
          window.location.href = `${loginUrl}?ReturnUrl=${window.location.pathname}`;
        }
        return throwError(() => error);
      }),
      // HACK: As of .NET 8 preview 5, some non-error responses still need to be redirected to login page.
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.url?.startsWith(loginUrl)) {
          window.location.href = `${loginUrl}?ReturnUrl=${window.location.pathname}`;
        }
        return event;
      }));
    }
  }
